import SearchModule from './SearchModule'
export default SearchModule
